var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 26.1238V9.43058C6.53125 7.94284 6.53125 7.19897 6.82537 6.63276C7.07322 6.15562 7.46226 5.76658 7.9394 5.51873C8.50561 5.22461 9.24948 5.22461 10.7372 5.22461H12.6263C13.2759 5.22461 13.6008 5.22461 13.9062 5.29921C14.1659 5.36261 14.4142 5.46549 14.6426 5.60423C14.9113 5.76745 15.1409 5.99714 15.6003 6.45651L17.0552 7.91131C17.5146 8.37069 17.7442 8.60037 18.0129 8.76359C18.2413 8.90234 18.4896 9.00521 18.7493 9.06861C19.0547 9.14321 19.3796 9.14321 20.0293 9.14321H20.6121C22.0999 9.14321 22.8437 9.14321 23.4098 9.43733C23.887 9.68518 24.2761 10.0742 24.5239 10.5514C24.8181 11.1176 24.8181 11.8614 24.8181 13.3492V16.6931C24.8181 18.1808 24.8181 18.9247 24.5239 19.4908C24.2761 19.968 23.887 20.3571 23.4098 20.6049C22.8437 20.899 22.0999 20.899 20.6121 20.899H20.0293C19.3796 20.899 19.0547 20.899 18.7493 20.8244C18.4896 20.761 18.2413 20.6582 18.0129 20.5194C17.7442 20.3562 17.5146 20.1265 17.0552 19.6671L15.6003 18.2123C15.1409 17.7529 14.9113 17.5233 14.6426 17.36C14.4142 17.2213 14.1659 17.1185 13.9062 17.055C13.6008 16.9804 13.2759 16.9804 12.6263 16.9804H11.7561",
    stroke: "#5D697C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.b0f8788784cf76f682d0fd2098499408.svg";
export { ForwardRef as ReactComponent };